export const getColor = (text: string | number): string => {
    if (typeof text === "string") {
      return "newcomer";
    } else {
      if (text<=20) return 'free';
      if (text<=40) return 'average';
      if (text<=70) return 'high';
      if (text<=100 ) return 'full';
    }
    return 'default';
  };